var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopRightQuarterCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 90,
    viewBox: "0 0 67 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.522 33.556C159.522 45.4172 157.298 54.5485 153.365 61.6046C149.443 68.6393 143.736 73.7681 136.495 77.5014C121.868 85.0427 101.137 86.8269 76.8198 86.8269C53.2024 86.8269 34.8944 77.497 22.4468 62.3532C9.9575 47.1587 3.24123 25.946 3.24123 2.06438C3.24123 -21.806 9.94822 -40.8082 22.3339 -53.8292C34.7033 -66.8332 53.0133 -74.1631 76.8198 -74.1631C100.069 -74.1631 120.707 -59.4449 135.652 -38.3452C150.583 -17.2669 159.522 9.78189 159.522 33.556Z",
    stroke: "url(#paint0_linear_1598_4095)",
    strokeWidth: 4.70903
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1598_4095",
    x1: 81.3817,
    y1: -76.5176,
    x2: 81.3817,
    y2: 89.1814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30004A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF1259"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopRightQuarterCircle);
export default __webpack_public_path__ + "static/media/TopRightQuarterCircle.1fcda36f.svg";
export { ForwardRef as ReactComponent };